import clsx from 'clsx'
import React from 'react'
import style from './style.module.scss'

type accessPriceProps = {
    classNames?: string[]
    access?: string
    price?: number
    forTile?: boolean
}

export const AccessPrice: React.FC<accessPriceProps> = ({
    classNames = [],
    access,
    price,
    forTile = false,
}) => {
    if (!access) {
        return null
    }

    return (
        <div className={clsx(style.price, forTile ? style.forTile : undefined, ...classNames)}>
            {access === 'free' ? (
                <span>Accès libre</span>
            ) : (
                price && (
                    <>
                        <i className="fi fi-rs-ticket" />
                        <span>À partir de {price}€</span>
                    </>
                )
            )}
        </div>
    )
}
